import pythonApi from '../api/pythonApi';

class ComponentSchemaService {

  getComponentSchemas = async (compType?: string, source?: string, sensorBoxType?: string) => {
    let url = '/api/v1/component-schema';
    const params = new URLSearchParams();
    if (compType) {
      params.append('comp_type', compType);
    }
    if (source) {
      params.append('source', source);
    }
    if (sensorBoxType) {
      params.append('sensor_box_type', sensorBoxType);
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    return await pythonApi.get(url);
  }
   
}

export default new ComponentSchemaService();